import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const DocPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Doc}
        fetchRecordsUrl={AdminReqUrls.admin__doc__mainPage_fetch_recordList}
    />)
});
export default DocPage;
